

export default {
  name: 'setting',
  components: {
  },
  created() {

    let t = this;


  },
  activated() {

    let t = this;

  },
  methods: {
    switchApp() {
      let t = this;
      let app = '';
      if (t.appMode == 'cleaner')
        app = 'employee';
      else if (t.appMode == 'employee')
        app = 'cleaner';

      
      location.replace('/#/' + app);
      location.reload();
    },
  },
  data() {
    return {
    };
  },
  computed: {
  }
};
